import type { RouteRow } from '@components/DriverTracking/Routes/api/schema'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useRouteAPI = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useRouteMetadata = () => {
    const payload = {}
    return useQuery({
      queryKey: ['routeMetadata', payload],
      queryFn: () => api.post('logistics/route/metadata', payload),
    })
  }

  const useRouteOverview = (locationID: string | null) => {
    const queryResult = useQuery<RouteRow[]>({
      queryKey: ['routeOverview', locationID],
      queryFn: () => api.post('logistics/route/overview', { location_id: locationID }),
      enabled: !!locationID,
    })
    return {
      ...queryResult,
      isLoading: !locationID ? false : queryResult.isPending,
    }
  }

  type RouteUpdatePayload = {
    id: string
    time_override?: number
    distance_override?: number
    payroll_distance_override?: number
  }

  const useRouteUpdate = useMutation<RouteRow, unknown, RouteUpdatePayload, unknown>({
    mutationKey: ['formsUpsert'],
    mutationFn: (payload) => api.post('logistics/route/update', payload),
  })

  return {
    useRouteMetadata,
    useRouteOverview,
    useRouteUpdate,
  }
}
